import { EXPORT_CURRENT_FPS, EXPORT_QUALITY, EXPORT_RESOLUTION } from '@/utils/const';
import request from '@/utils/request';

import { ApiResponse, ApiResult } from '.';

interface IProjectProps {
  projectName?: string;
  fileSize?: number;
  coverUrl?: string;
  downloadUrl?: string;
  desc?: string;
  extendInfo?: any;
  visible?: number;
}
interface ProjectData extends IProjectProps {
  projectId: number;
  version?: number;
}

interface ProjectBase {
  projectId?: number;
  version?: number;
}

interface ITemplateItemPrj {
  downloadUrl: string;
  eventFromTemplateInfo: string;
  prjResourceType: number;
  width: number;
  height: number;
  iconFromTemplate: string;
  subTcid: string;
  tcid: string;
  templateCode: string;
  templateExtend: string;
  templateRule: string;
  titleFromTemplate: string;
  fileId: string | number;
}
interface IProjectDetailData {
  assets: Array<ITemplateItemPrj>;
  templates: Array<ITemplateItemPrj>;
  correct: boolean;
  coverUrl: string;
  downloadUrl: string;
  projectId: number;
  projectName: string;
  status: number;
  version: number;
  extendInfo: string;
  createTime: number;
}

export interface IClipItem {
  clipId: string; // 数字人所在comp 的 uuid
  clipTemplateCode?: string; //当前clip使用的素材code
  ttsUrl?: string; //
}
/**
 * 视频导出传参数
 */
interface IExportData {
  projectId: number;
  title?: string;
  version?: number;
  projectWidth: number;
  projectHeight: number;
  resolution?: number;
  fps?: number;
  quality?: number;
  projectDuration?: number;
  clips?: Array<IClipItem>; //仅需要数字人的clip
}

/**
 * 新建工程
 * @param data
 * @returns
 */
export const projectAdd = async (
  data: IProjectProps,
): Promise<ApiResult<ProjectBase>> => {
  const res = await request('/api/rest/dlt/project/add', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 更新工程
 * @param data
 * @returns
 */
export const projectUpdate = async (data: ProjectData): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/project/update', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 工程详情
 * @param data
 * @returns
 */
export const projectDetail = async (
  projectId: number,
): Promise<ApiResult<IProjectDetailData>> => {
  const res = await request('/api/rest/dlt/project/detail', {
    method: 'POST',
    data: { projectId },
  });
  return res;
};

/**
 * 视频导出
 * @param data
 * @returns
 */
export const projectExport = async (data: IExportData): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/project/export/submit', {
    method: 'POST',
    data: {
      quality: EXPORT_QUALITY,
      fps: EXPORT_CURRENT_FPS,
      resolution: EXPORT_RESOLUTION,
      // customType: '30',
      ...data,
    },
  });
  return res;
};

/**
 * 编辑器视频导出
 * @param data
 * @returns
 */
export const videoEditorProjectExport = async (
  data: IExportData,
): Promise<ApiResult<any>> => {
  const res = await request('/api/rest/dlt/project/edit/export/submit', {
    method: 'POST',
    data: {
      quality: EXPORT_QUALITY,
      fps: EXPORT_CURRENT_FPS,
      resolution: EXPORT_RESOLUTION,
      ...data,
    },
  });
  return res;
};

export const deleteVideo = async <T>(ids: number[]): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/asset/del', {
    method: 'POST',
    data: {
      ids,
    },
  });
  return res;
};
